export function parseTime(date, fmt) {
	var o = {
		'M+': date.getMonth() + 1, //月份
		'd+': date.getDate(), //日
		'h+': date.getHours(), //小时
		'm+': date.getMinutes(), //分
		's+': date.getSeconds(), //秒
		'q+': Math.floor((date.getMonth() + 3) / 3), //季度
		S: date.getMilliseconds() //毫秒
	}
	if (/(y+)/.test(fmt))
		fmt = fmt.replace(
			RegExp.$1,
			(date.getFullYear() + '').substr(4 - RegExp.$1.length)
		)
	for (var k in o)
		if (new RegExp('(' + k + ')').test(fmt))
			fmt = fmt.replace(
				RegExp.$1,
				RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
			)
	return fmt
}

/**
 * 将一维的扁平数组转换为多层级对象
 * @param  {[type]} list 一维数组，数组中每一个元素需包含id和pid 最外层pid为'0'
 * @return {[type]} tree 多层级树状结构
 */
export function buildTree(list) {
	let tree = list.filter(father => {
		//循环所有项
		let branchArr = list.filter(child => {
			return father.id == child.pid //返回每一项的子级数组
		})
		if (branchArr.length > 0) {
			father.children = branchArr //如果存在子级，则给父级添加一个children属性，并赋值
		}
		return father.pid === '0' //返回第一层
	})
	return tree //返回树形数据
}

// 存储session
export function setSession(key, val) {
	if (typeof val === 'object') {
		sessionStorage.setItem(key, JSON.stringify(val))
	} else {
		sessionStorage.setItem(key, val)
	}
}

// 获取session
export function getSession(key) {
	const val = sessionStorage.getItem(key)
	return val
}

// 下载图片
export function downloadIamge(imgsrc, name) {
	//下载图片地址和图片名
	let image = new Image()
	// 解决跨域 Canvas 污染问题
	image.setAttribute('crossOrigin', 'anonymous')
	image.onload = function() {
		let canvas = document.createElement('canvas')
		canvas.width = image.width
		canvas.height = image.height
		let context = canvas.getContext('2d')
		context.drawImage(image, 0, 0, image.width, image.height)
		let url = canvas.toDataURL('image/png') //得到图片的base64编码数据
		let a = document.createElement('a') // 生成一个a元素
		let event = new MouseEvent('click') // 创建一个单击事件
		a.download = name || 'photo' // 设置图片名称
		a.href = url // 将生成的URL设置为a.href属性
		a.dispatchEvent(event) // 触发a的单击事件
	}
	image.src = imgsrc
}

export function toFixed(number) {
	let sNumber = String(number)
	if (
		sNumber.indexOf('.') > -1 &&
		sNumber.slice(sNumber.indexOf('.') + 1).length > 2
	) {
		let sn = sNumber.slice(0, sNumber.indexOf('.'))
		let en = sNumber.slice(sNumber.indexOf('.') + 1)
		if (en.indexOf('9999999') == 2 || en.indexOf('9999999') == 1) {
			en = Number(en.slice(0, 2)) + 1 + ''
		} else {
			en = en.slice(0, 2)
		}
		return Number(sn + '.' + en)
	} else {
		return Number(number)
	}
}
